var $e4ace6955cffe8c2$exports = {};
$e4ace6955cffe8c2$exports = {
    "collapse": `R\xe9duire`,
    "expand": `D\xe9velopper`
};


export {$e4ace6955cffe8c2$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
